







































import SplitPane from 'vue-splitpane'
import { Component, Vue } from 'vue-property-decorator'
import { isGuacAuthenticatedForTerminal, authenticateGuacTerminal } from "@/utils/timeHelpers";

@Component({
  name: 'Wireshark',
  components: {SplitPane}
})
export default class extends Vue {
  private dialogVisible: boolean = false;
  private modalTitle: string = "";
  private modalMessage: string = "";
  created() {
    document.addEventListener("click", this.refocusGuacamole);
    document.addEventListener("keydown", this.refocusGuacamole);
    this.verifyGuacAuthentication();
  }

  destroyed() {
    document.removeEventListener("click", this.refocusGuacamole);
    document.removeEventListener("keydown", this.refocusGuacamole);
  }

  private verifyGuacAuthentication() {
    if (!isGuacAuthenticatedForTerminal()) {
      this.modalTitle = "Guacamole Terminal - Session expired";
      this.modalMessage =  "Session for Guacamole Terminal expired. Redirect for authentication.";
      this.dialogVisible = true;
    }
  }

  private handleGuacAuthentication() {
    authenticateGuacTerminal()
    this.dialogVisible = false;
  }

  refocusGuacamole() {
    // Do not refocus if focus is on an input field
    let focused = document.activeElement;
    // let controlPanelItem = (this.$refs.controlPanelItem as Vue).$el as HTMLElement;

    // let collapseContent = controlPanelItem.firstChild as HTMLElement;

    // if (focused && focused !== controlPanel)
    //   controlPanelItem.classList.remove("is-active");
    if (
      focused &&
      focused !== document.body
      // focused !== collapseContent.firstChild
    )
      return;
    // Ensure iframe is focused
    let iframe = this.$refs.guac as HTMLElement;
    iframe.focus();
  }

  resize() {
    // Handle resize
  }
}
